export const nameYourQuizDataSet = { cy: 'name-your-quiz-input' };
export const nameYourQuizContinuebuttonDataSet = { cy: 'name-your-quiz-continue-button' };
